import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import ImageGalleryStrip from '../components/ImageGalleryStrip';

const Home = () => {
  const images = {
    hero: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/wxxiaj3k_Honey%20Sofia%20-%201298-Edit-face%20blur.jpg',
    heroMobile: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/wxxiaj3k_Honey%20Sofia%20-%201298-Edit-face%20blur.jpg',
    gallery1: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/aed5noou_Honey_0021-Edit-Edit.jpg',
    gallery2: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/bc1wkman_Honey_0069-Edit-Edit.jpg',
    gallery3: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/7e4ktww2_Honey_0172-Edit.jpg',
    gallery4: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/yrswgd29_WHP_5600.jpg'
  };

  const galleryImages = [
    { id: 'gallery-1', src: images.gallery1 },
    { id: 'gallery-2', src: images.gallery2 },
    { id: 'gallery-3', src: images.gallery3 },
    { id: 'gallery-4', src: images.gallery4 }
  ];

  return (
    <div>
      {/* Hero Section */}
      <HeroSection
        desktopImage={images.hero}
        mobileImage={images.heroMobile}
        title="Where time slows down,<br />and connection deepens."
        description="Step away from the ordinary. Into a space where chemistry is palpable, conversation flows effortlessly, and every moment is designed to make you feel seen, desired, and utterly captivated."
        ctaText="Enquire"
        ctaLink="/bookings"
      />

      {/* Intro Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <p className="body-large" style={{ lineHeight: '1.8', color: 'var(--text-primary)' }}>
              I'm Honey — warm, intuitive, and effortlessly engaging. I create a space where desire meets ease, where you can let your guard down and simply... feel. Whether you crave playful spontaneity or something deeper and more deliberate, I meet you exactly where you are.
            </p>
          </div>
        </div>
      </section>

      {/* Experience Split Section */}
      <section className="section-padding-small" style={{ background: 'var(--bg-subtle)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px', color: 'var(--text-primary) !important' }}>
                Tender & Immersive
              </h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary) !important' }}>
                Soft laughter. Lingering glances. The kind of closeness that feels effortless and utterly intoxicating.
              </p>
            </div>
            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px', color: 'var(--text-primary) !important' }}>
                Bold & Unapologetic
              </h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary) !important' }}>
                Raw energy. Unfiltered desire. The experience you've been craving but hesitant to ask for.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery Strip */}
      <ImageGalleryStrip images={galleryImages} />

      {/* Social Links Section */}
      <section style={{ padding: '60px 40px', background: 'var(--bg-primary)', textAlign: 'center' }}>
        <div className="container">
          <h3 className="heading-3" style={{ marginBottom: '24px' }}>
            Follow My Journey
          </h3>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '32px',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}>
            <a 
              href="https://bsky.app/profile/honeysofia.bsky.social" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px',
                color: 'var(--burgundy)',
                textDecoration: 'none',
                fontSize: '18px',
                fontFamily: 'Raleway, sans-serif',
                fontWeight: '600',
                transition: 'opacity 0.2s ease',
                padding: '16px 24px',
                border: '2px solid var(--burgundy)',
                borderRadius: '0'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.8';
                e.currentTarget.style.background = 'rgba(90, 30, 43, 0.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"/>
              </svg>
              Follow me on Bluesky @honeysofia
            </a>
            <a 
              href="https://throne.com/honeysofia" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px',
                color: 'var(--burgundy)',
                textDecoration: 'none',
                fontSize: '16px',
                fontFamily: 'Raleway, sans-serif',
                transition: 'opacity 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.7'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.842 3.158A8 8 0 1012 20.842 8 8 0 0020.842 3.158zm-9.034 12.28l-4.596-4.596 1.414-1.414 3.182 3.182 6.364-6.364 1.414 1.414-7.778 7.778z"/>
              </svg>
              Wishlist
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section style={{ padding: '100px 40px', background: 'var(--bg-subtle)', textAlign: 'center' }}>
        <div className="container">
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 className="hero-medium" style={{ marginBottom: '32px' }}>
              Ready to explore what's possible between us?
            </h2>
            <Link 
              to="/bookings" 
              className="btn-primary"
              style={{
                background: 'var(--burgundy)',
                color: '#fff',
                border: '2px solid var(--burgundy)',
                fontWeight: '700',
                letterSpacing: '1px'
              }}
            >
              Book Your Experience
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
